import { ReleaseKey } from "./key";
import { SimpleQueryOptions, useBaseQuery } from "../baseQuery";
import { GetReleaseHistoryRequest, GetReleaseHistoryResponse } from "@maven-rest/docs/ReleaseHistory.internal.dto";
import { ReleaseHistoryInternalUrl } from "@maven-rest/docs/ReleaseHistory.internal.url";

export function useReleaseHistoriesQuery(options?: SimpleQueryOptions<GetReleaseHistoryResponse, GetReleaseHistoryRequest>) {
  return useBaseQuery({
    queryKey: [ReleaseKey.ReleaseHistory],
    fnOption: {
      url: ReleaseHistoryInternalUrl.getReleaseHistories,
    },
    ...options,
  });
}
